import { classnames } from '@/utils/classnames/classnames';
import { TableHTMLAttributes, useEffect, useState } from 'react';

const TableContainer = ({ className, ...props }: TableHTMLAttributes<HTMLTableElement>) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) return null;
  const tableClassName = classnames(
    'relative block w-full overflow-x-auto rounded-md border-t border-neutral-400 md:table',
    className,
  );
  return <table className={tableClassName} {...props} />;
};

export default TableContainer;